import { Draggable } from "react-beautiful-dnd";
import accept_icon from "../../common/assets/images/accepticon.png";
import delete_icon from "../../common/assets/images/deleteIcon.png";
import codebook_icon from "../../common/assets/images/codeBookHighlight.png";
import source_doc_ref from "../../common/assets/images/sourcedocIcon.png";
import bar_icon from "../../common/assets/images/ThreeLines.png";
import { Dropdown } from "react-bootstrap";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { codeReferenceClick } from "./Service";
import { useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { has } from "lodash";
import { useLocation } from "react-router-dom";
// import mockLabels from "./mock";
// import ReferencePopUp from "./ReferencePopUp";

const DraggableItem = ({
  item,
  type,
  index,
  accepted,
  handleAccept,
  handleDelete,
  handleCodebookClick,
  selectedCofValues,
  handleCofSelect,
  codingscreendata,
  iconDisplay,
  newlyInsertedCodes,
  handleAcceptCodes,
  hacStatus,
  drgConfirmedStatusUpdate,
}) => {
  //console.log(codingscreendata, accepted, hacStatus,item, "checkedheredrags");
  const [sourceLoading, setSourceLoading] = useState(false);
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const drgConfirmedStatus = codingscreendata?.data?.meta?.status;
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);
  const [open, setOpen] = useState(false);
  const [codeOpen,setCodeOpen]=useState(false);
  // const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const { documentViewerData } = useSelector(
    (state) => state.documentViewer.documentViewer
  );
  const location = useLocation();
  // const [popupData, setPopupData] = useState(null);
  const getReasoningId = (code) => {
    //console.log('jk',code);

    const documents = documentViewerData?.documents;
    for (const document of documents) {
      const reasoning = document.reasonings.find(
        (r) => r.document_codes === code
      );
      if (reasoning) {
        handleReferenceClick(code, reasoning.reasoning_id);
      }
    }
    return null; // Return null if not found
  };
  const handleReferenceClick = (code, reasoningId) => {
    setSourceLoading(true);
    codeReferenceClick(code, reasoningId)
      .then((res) => {
        const fileUrl = res?.data?.download_url;
        const filename = fileUrl.split("/").pop().split("?")[0];
        fetch(fileUrl)
          .then((response) => response.text())
          .then((data) => {
            const newWindow = window.open("", "_blank");
            if (newWindow) {
              newWindow.document.body.innerHTML = `<pre>${data}</pre>`;
            } // Display content inside <pre> tag
            newWindow.document.title = filename;
          })
          .catch((error) => console.error("Error fetching file:", error));
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSourceLoading(false);
      });
  };
  // const findOrigin = (code) => {
  //   const allCodes = [
  //     ...(codingscreendata?.data?.procedure_codes || []),
  //     ...(codingscreendata?.data?.additional_diagnoses || []),
  //     ...(codingscreendata?.data?.principal_diagnosis || []),
  //   ];

  //   const foundItem = allCodes.find((entry) => entry.code === code);
  //   return foundItem ? foundItem.origin : null;
  // };
  const isAIOrigin = item.origin === "AI";
  const isProviderOrUser = item.origin === "P" || item.origin === "U";
  const isOnlyUser = item.origin === "U";
  const isOnlyUserAudited = item.origin === "AU";

  const shouldShowAccept = isAIOrigin;
  const shouldShowDelete = isAIOrigin || isProviderOrUser;
  const shouldShowSource = isAIOrigin;
  const shouldShowCodebook = isAIOrigin || isProviderOrUser;
  //console.log(shouldShowAccept, accepted?.[item.code],drgConfirmedStatusUpdate,"see");

  const handleDescriptionTap = () => {
    if (isTouchDevice) {
      setOpen(true);
      // Auto-close after a short time (e.g., 2 seconds)
      setTimeout(() => setOpen(false), 2000);
    }
  };
    const handleCodeTap = () => {
      console.log('hjgfhjkhgfcxghjkhgcv');
      
    if (isTouchDevice) {
      setCodeOpen(true);
      // Auto-close after a short time (e.g., 2 seconds)
      setTimeout(() => setCodeOpen(false), 2000);
    }
  };

  return (
    <Draggable
      key={`${type}-${item.code}-${index}`}
      draggableId={`${type}-${item.code}-${index}`}
      index={index}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`draggable-item label-wrapper-scroll ${
            snapshot.isDragging ? "dragging" : ""
          }`}
          style={provided.draggableProps.style}
        >
          <div
            className={`label-wrapper ${
              type === "procedure"
                ? newlyInsertedCodes?.includes(item?.code)
                  ? location.pathname === "/Auditor-Coding-Screen" ||
                    location.pathname === "/Auditor-CodeAssist-Screen"
                    ? "newly-auditor-inserted"
                    : "newly-inserted"
                  : ""
                : newlyInsertedCodes?.includes(item?.code?.replace(/^[12]/, ""))
                ? location.pathname === "/Auditor-Coding-Screen" ||
                  location.pathname === "/Auditor-CodeAssist-Screen"
                  ? "newly-auditor-inserted"
                  : "newly-inserted"
                : ""
            }`}
            style={{
              fontWeight: accepted?.[item?.code]
                ? "normal"
                : isAIOrigin
                ? "bold"
                : "normal",
              color: isOnlyUserAudited
                ? "red"
                : isOnlyUser
                ? "#2f759e"
                : "inherit",
            }}
          >
            <img
              src={bar_icon}
              alt="threeline"
              style={{ paddingLeft: "12px" }}
            />

            {type !== "procedure" && (
              <Dropdown className="codingscreen-dropdown">
                <Dropdown.Toggle variant="light">
                  {typeof selectedCofValues[type]?.[index] === "object"
                    ? selectedCofValues[type]?.[index]?.cof
                    : selectedCofValues[type]?.[index] ?? item?.code?.charAt(0)}
                </Dropdown.Toggle>

                <Dropdown.Menu className="my-actions-dropdown">
                  {[1, 2].map((num) => (
                    <Dropdown.Item
                      key={num}
                      onClick={() =>
                        handleCofSelect(type, index, num, item.code.slice(1))
                      }
                    >
                      {num}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            )}
            <Tooltip
              title={
                hacStatus[item?.code?.replace(/^[12]/, "")] &&
                "This is Hospital Acquired Complication"
              }
            >
              <div style={{ width: "22px", height: "27px" }}>
                {hacStatus[item?.code?.replace(/^[12]/, "")] && (
                  <span className="hac-label">H</span>
                )}
              </div>
            </Tooltip>

            <Tooltip
              title={type === "procedure" ? item?.code : item?.code?.slice(1)}
              open={isTouchDevice ? codeOpen : undefined}
              disableHoverListener={isTouchDevice}
              disableTouchListener
            >
              <span className="code-name" onClick={handleCodeTap}>
                {type === "procedure" ? item?.code : item?.code?.slice(1)}
              </span>
            </Tooltip>
            <Tooltip
              title={item.description}
              open={isTouchDevice ? open : undefined}
              disableHoverListener={isTouchDevice}
              disableTouchListener
            >
              <span className="code-description" onClick={handleDescriptionTap}>{item.description}</span>
            </Tooltip>
            {/* {mockLabels.map((item) => {
              return <span className="reference-label" onClick={()=>setPopupData(true)} key={item}>{item.labels}</span>;
            })} */}
            {/* Conditionally render icons based on origin */}
            {/* {location.pathname !== "/Code-Assist" ? ( */}
            <div className="d-flex gap-2 ms-auto coding-action-icons">
              {shouldShowAccept &&
                !accepted?.[item.code] &&
                !(
                  drgConfirmedStatus === "Coding Complete" ||
                  drgConfirmedStatusUpdate
                ) && (
                  <Tooltip title="Accept Code">
                    <img
                      src={accept_icon}
                      alt="Accept"
                      onClick={() => handleAcceptCodes(item.code)}
                    />
                  </Tooltip>
                )}

              {iconDisplay ? (
                <>
                  <Tooltip title="Delete Code">
                    <img
                      src={delete_icon}
                      alt="Delete"
                      onClick={() => handleDelete(type, index)}
                    />
                  </Tooltip>

                  {/* <Tooltip title="Delete Code">
                      <img
                        src={delete_icon}
                        alt="Delete"
                        onClick={() => handleDelete(type, index)}
                      />
                    </Tooltip> */}
                  <Tooltip title="View in Codebook">
                    <img
                      src={codebook_icon}
                      alt="Codebook"
                      onClick={() =>
                        handleCodebookClick(
                          type === "procedure" ? item.code : item.code.slice(1),
                          /^[0-9]+$/.test(item?.code)
                            ? codebookusaEnv
                              ? "CPT"
                              : "ACHI"
                            : type === "procedure"
                            ? codebookusaEnv
                              ? "PCS"
                              : "ACHI"
                            : "ICD"
                        )
                      }
                    />
                  </Tooltip>
                </>
              ) : (
                <>
                  {shouldShowDelete && (
                    <Tooltip title="Delete Code">
                      <img
                        src={delete_icon}
                        alt="Delete"
                        onClick={() => handleDelete(type, index)}
                      />
                    </Tooltip>
                  )}
                  {shouldShowCodebook && (
                    <Tooltip title="View in Codebook">
                      <img
                        src={codebook_icon}
                        alt="Codebook"
                        onClick={() =>
                          handleCodebookClick(
                            type === "procedure"
                              ? item.code
                              : item.code.slice(1),
                            /^[0-9]+$/.test(item?.code)
                              ? codebookusaEnv
                                ? "CPT"
                                : "ACHI"
                              : type === "procedure"
                              ? codebookusaEnv
                                ? "PCS"
                                : "ACHI"
                              : "ICD"
                          )
                        }
                      />
                    </Tooltip>
                  )}
                </>
              )}

              {sourceLoading ? (
                <FaSpinner />
              ) : (
                shouldShowSource && (
                  <Tooltip title="Source Document">
                    <img
                      onClick={() => getReasoningId(item?.code?.slice(1))}
                      src={source_doc_ref}
                      alt="Source"
                    />
                  </Tooltip>
                )
              )}
            </div>
          </div>
          {/* {popupData && <ReferencePopUp/>} */}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableItem;
